/* tslint:disable */
import {
  PropertyUnits
} from '../index';

declare var Object: any;
export interface UnitFeatureInterface {
  "name": string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  propertyUnits?: PropertyUnits[];
}

export class UnitFeature implements UnitFeatureInterface {
  "name": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  propertyUnits: PropertyUnits[];
  constructor(data?: UnitFeatureInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UnitFeature`.
   */
  public static getModelName() {
    return "UnitFeature";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UnitFeature for dynamic purposes.
  **/
  public static factory(data: UnitFeatureInterface): UnitFeature{
    return new UnitFeature(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UnitFeature',
      plural: 'UnitFeatures',
      path: 'UnitFeatures',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        propertyUnits: {
          name: 'propertyUnits',
          type: 'PropertyUnits[]',
          model: 'PropertyUnits',
          relationType: 'hasMany',
          modelThrough: 'PropertyUnitFeature',
          keyThrough: 'property_unit_id',
          keyFrom: 'id',
          keyTo: 'unit_feature_id'
        },
      }
    }
  }
}
